module.exports = __webpack_public_path__ + "static/media/muscu-cardio.0a159765.jpg";